/**
 * PublicationDetail
 */
import React from 'react';
/** Publication details. */
var PublicationDetail = function (_a) {
    var text = _a.text, heading = _a.heading;
    return (React.createElement("div", { className: "block md:flex mb-2" },
        React.createElement("dt", { className: "text-greyDarker text-p w-1/3 md:w-1/5" }, heading),
        React.createElement("dd", { className: "text-black md:text-greyDarker text-p md:ml-4 w-2/3 md:w-4/5" }, text)));
};
export default PublicationDetail;
